export default __webpack_public_path__ + "static/media/bkg-location-lifestyle-1.97b22e57.jpg";